import FFClickOutside from './directives/ClickOutside.js'
import FFTooltip from './directives/Tooltip.js'

export default {
    FFClickOutside,
    FFTooltip
}
